import { Flex, Stack, Text, desktopFirstMediaQuery } from '@inflearn/ds-react-next';
import { useTranslation } from 'next-i18next';

import { CourseCardMenu } from './CourseCardMenu';
import type { CourseCardData } from './courseCardDataTransformer';

export function CourseCardMetaInfo({
  completeCount,
  expireInformation,
  lectureCount,
  progress,
  hasCertificate,
  course,
  isArchived,
  isArchivable,
  isCancelable,
  voucherId,
  isPartners,
}: Pick<
  CourseCardData,
  | 'expireInformation'
  | 'completeCount'
  | 'progress'
  | 'hasCertificate'
  | 'course'
  | 'isArchived'
  | 'isArchivable'
  | 'isCancelable'
  | 'voucherId'
> & { lectureCount: number; isPartners: boolean }) {
  const { t } = useTranslation();

  return (
    <Flex w="100%">
      <Stack
        gap={0}
        w="100%"
        styles={{
          root: {
            'span, p': {
              fontSize: 14,
            },
            [desktopFirstMediaQuery.mobile]: {
              'span, p': {
                fontSize: 12,
              },
            },
          },
        }}
      >
        <Flex gap={2}>
          <Text component="span" fw={600} c="gray.7">
            {completeCount}
          </Text>
          <Text component="span" c="gray.7">
            / {t('{{count}}강', { count: lectureCount, context: 'courseCard' })}
          </Text>
          <Text component="span" c="gray.7">
            ({progress}%)
          </Text>
        </Flex>
        <Text c={expireInformation.isExpired ? 'red.6' : 'gray.6'}>{expireInformation.label}</Text>
      </Stack>
      <CourseCardMenu
        hasCertificate={hasCertificate}
        isOfflineCourse={course.isOfflineCourse}
        isArchived={isArchived}
        isArchivable={isArchivable}
        isCancelable={isCancelable}
        courseId={course.courseId}
        voucherId={voucherId}
        isPartners={isPartners}
      />
    </Flex>
  );
}
